// --- GARAGE SERVICE ---
export const SOFTLINE_API_GARAGE_MECHANICS = 'garage-service/garage/mechanics';
export const SOFTLINE_API_GARAGE_MECHANIC_TIME_REPORTS =
  'garage-service/garage/mechanics/{{id}}/time-report';
export const SOFTLINE_API_GARAGE_MECHANIC_TIME_REPORT_STOP =
  'garage-service/garage/mechanics/{{id}}/time-report/stop';
export const SOFTLINE_API_GARAGE_MECHANIC_TIME_REPORT_ORDER =
  'garage-service/garage/order/{{orderId}}/mechanics/{{mechanicId}}/time-report';
export const SOFTLINE_API_GARAGE_UNFINISHED_ORDERS =
  'garage-service/garage/mechanics/{{id}}/unfinished-orders';

export const SOFTLINE_API_GARAGE_NOTIFICATION =
  'garage-service/garage/orders/{{id}}/notification';
export const SOFTLINE_API_GARAGE_NOTIFICATION_TEMPLATE =
  'garage-service/garage/orders/{{id}}/notification/templates';

export const SOFTLINE_API_GARAGE_ORDER = 'garage-service/garage/orders/{{id}}';
export const SOFTLINE_API_GARAGE_ORDERS = 'garage-service/garage/orders';
export const SOFTLINE_API_GARAGE_ORDERS_DEFAULT = 'garage-service/garage/orders/default';
export const SOFTLINE_API_GARAGE_ORDER_ITEMS =
  'garage-service/garage/orders/{{id}}/items';
export const SOFTLINE_API_GARAGE_ORDER_ITEM = 'garage-service/garage/orders/items';
export const SOFTLINE_API_GARAGE_ORDER_ITEM_DEFAULT =
  'garage-service/garage/orders/items/default';
export const SOFTLINE_API_GARAGE_ORDER_ITEM_UPDATE =
  'garage-service/garage/orders/items/{{id}}';
export const SOFTLINE_API_GARAGE_ORDER_ITEM_DELETE =
  'garage-service/garage/orders/items/{{id}}';
export const SOFTLINE_API_GARAGE_ORDER_NOTES =
  'garage-service/garage/orders/{{id}}/notes';
export const SOFTLINE_API_GARAGE_ORDER_PRINT =
  'garage-service/garage/orders/{{id}}/print';
export const SOFTLINE_API_GARAGE_ORDER_SIGN = 'garage-service/garage/orders/{{id}}/sign';
export const SOFTLINE_API_GARAGE_ORDER_CLOSE =
  'garage-service/garage/orders/{{id}}/close';
export const SOFTLINE_API_GARAGE_ORDER_ARCHIVE_KEY =
  'garage-service/garage/orders/{{id}}/archivekey';
export const SOFTLINE_API_GARAGE_ORDER_TASKS = 'garage-service/garage/orders/tasks';
export const SOFTLINE_API_GARAGE_ORDER_TIME_REPORTS =
  'garage-service/garage/orders/{{id}}/time-report';

// Time Report CRUD (explicit from/to entries, not stamp-based).
export const SOFTLINE_API_GARAGE_TIME_REPORT = 'garage-service/garage/time-report';
export const SOFTLINE_API_GARAGE_TIME_REPORT_ID =
  'garage-service/garage/time-report/{{id}}';
export const SOFTLINE_API_GARAGE_MECHANIC_TIME_REPORT_STOP_ALL =
  'garage-service/garage/mechanics/{{id}}/time-report/stop-all';

export const SOFTLINE_API_GARAGE_ROSTER_PRINT =
  'garage-service/garage/employees/{{id}}/roaster/print';
export const SOFTLINE_API_GARAGE_ROSTER_CONFIG = 'garage-service/garage/roster/config';

export const SOFTLINE_API_GARAGE_FILE = 'v2/file';

export const SOFTLINE_API_GARAGE_SCAN = 'garage-service/garage/scan/{{type}}/{{barcode}}';

export const SOFTLINE_API_GARAGE_ITEM_SCAN = '/v2/items/scan/{{labelType}}/{{data}}';

export const SOFTLINE_API_GARAGE_TASK = 'garage-service/garage/tasks/{{id}}';
export const SOFTLINE_API_GARAGE_TASKS = 'garage-service/garage/tasks';

export const SOFTLINE_API_GARAGE_VEHICLE = 'garage-service/garage/vehicles/{{id}}';
export const SOFTLINE_API_GARAGE_VEHICLES = 'garage-service/garage/vehicles';
export const SOFTLINE_API_GARAGE_VEHICLE_MILEAGE =
  'garage-service/garage/vehicles/{{id}}/mileage-history';

// --- PRODUCT SERVICE ---
export const SOFTLINE_API_PRODUCT_ORDER = 'garage-service/product/orders/{{id}}';
export const SOFTLINE_API_PRODUCT_ORDERS = 'garage-service/product/orders';
export const SOFTLINE_API_PRODUCT_ORDERS_DEFAULT =
  'garage-service/product/orders/default';
export const SOFTLINE_API_PRODUCT_ORDER_ITEMS =
  'garage-service/product/orders/{{id}}/items';
export const SOFTLINE_API_PRODUCT_ORDER_ITEM = 'garage-service/product/orders/items';

// temporary until the product order item default endpoint is implemented in the product service
export const SOFTLINE_API_PRODUCT_ORDER_ITEM_DEFAULT =
  'garage-service/garage/orders/items/default';

  
export const SOFTLINE_API_PRODUCT_ORDER_ITEM_UPDATE =
  'garage-service/product/orders/items/{{id}}';
export const SOFTLINE_API_PRODUCT_ORDER_ITEM_DELETE =
  'garage-service/product/orders/items/{{id}}';
export const SOFTLINE_API_PRODUCT_UNFINISHED_ORDERS =
  'garage-service/product/mechanics/{{id}}/unfinished-orders';

// --- ROSTER SERVICE ---
export const SOFTLINE_API_GARAGE_ROSTER_CONTENT_ENTRY =
  'roster-service/pms/roster/content/{{id}}';
export const SOFTLINE_API_GARAGE_ROSTER_DEPARTMENT_HEADS =
  'roster-service/pms/roster/departmenthead';
